
export const ROL_RANK_SUPERVISOR = "Rankings Supervisor";
export const ROL_RANK_VISUALIZADOR = "Rankings Visor";
export const ROL_RANK_CARGA = "Rankings Carga";

export const USUARIO_ACCESO_PRE = "RANKINGS TEST ACCESO";
export const USUARIO_ACCESO_PRO = "RANKINGS PROD ACCESO";